const addPx = value => {
	if (!value) return null
	if (typeof value === 'string') return value
	return `${value}px`
}

export default addPx
